/*
 * @Date: 2023-12-11 10:55:50
 * @LastEditors: shiguang
 * @LastEditTime: 2024-04-30 16:50:49
 * @FilePath: /Client/src/util/buryingPoint.ts
 * @Description:
 */
/** 数数埋点初始化 */
import { ref, onMounted, onBeforeUnmount, computed } from 'vue'
import thinkingdata from 'thinkingdata-browser'
import { useStore } from 'vuex'
// 业务类型
export enum BuType {
  'ZC' = 0,
  'DC' = 1
}

// 业务类型
export enum PlatformType {
  'PC' = 1,
}

const initThinkingData = () => {
  thinkingdata.init({
    appId:
      process.env.VUE_APP_ENV === 'prod'
        ? '2da850ddb9c04769a0b0de300767a72f'
        : 'a6f9d0a2f07149c0acc53a20db8d69da',
    serverUrl: 'https://global-receiver-ta.thinkingdata.cn',
    batch: true,
    send_method: 'ajax',
    showLog: false
  })
  // 开发环境
  const _env = process.env.VUE_APP_ENV as 'test' | 'pre' | 'prod'
  // 获取本地时间
  const localTime = new Date()
  // 计算UTC偏移量（以分钟为单位）
  const utcOffset = (localTime.getTimezoneOffset() / 60) * -1
  thinkingdata.setSuperProperties({
    env: _env,
    zone_offset: utcOffset,
    platform_type: PlatformType.PC,
    bu_type: BuType.DC,
    version: '1.0.0'
  })
}

/** 数数 设置用户 */
export const taSetUser = (customerRespDTO: any = {}, route: any) => {
  const localTime = new Date()
  // 计算UTC偏移量（以分钟为单位）
  const utcOffset = (localTime.getTimezoneOffset() / 60) * -1
  const timeZone = utcOffset >= 0 ? `UTC+${utcOffset}` : `UTC${utcOffset}`
  const user: any = {
    bu_type: BuType.DC,
    customer_id: customerRespDTO.customerId,
    customer_name: customerRespDTO.customerName,
    station_code: customerRespDTO.stationCode,
    super_customer_id: customerRespDTO.superCustomerId,
    system_source: customerRespDTO.systemSource,
    time_zone: timeZone,
    internal_flag: customerRespDTO.internalFlag,
    login_name: customerRespDTO.loginName,
    main_customer_id: customerRespDTO.mainCustomerId,
    nation_code: customerRespDTO.nationCode,
    unification_customer_full_name: customerRespDTO.unificationCustomerFullName
  }
  if (customerRespDTO.platformType) {
    user.platform_type = customerRespDTO.platformType
  }

  thinkingdata.login(customerRespDTO?.customerId)
  thinkingdata.userSet(user)
}

// ta 上报时间
enum TaEvent {
  /** 通用浏览/曝光用 page_view 事件  */
  PAGE_VIEW = 'page_view',
  /** 通用点击用 btn_click 事件 */
  BTN_CLICK = 'btn_click',
  /** Banner点击 */
  BANNER_CLICK = 'banner_click',
  /** 注册流程 */
  REGISTER = 'register',
  /** 注册方式点击  */
  REGISTER_METHOD_CLICK = 'register_method_click',
  /** 类目点击 */
  CATEGORY_CLICK = 'category_click',
  /** 商品搜索 */
  PRODUCT_SEARCH = 'product_search',
  /** 1688商品搜索 */
  PRODUCT_SEARCH_1688 = 'product_search_1688',
  /** 商详浏览 */
  PRODUCT_DETAIL_PAGEVIEW = 'product_detail_pageview',
  /** 注册弹窗 */
  PUPUP_WINDOW = 'pupup_window',
  /** 订单支付 */
  ORDER_PAY = 'order_pay'
}

interface TaEventParams {
  /** 上报事件 */
  event: TaEvent;
  /** 上报参数 */
  value?: Record<string, any>;
  /** 是否上传用户信息 */
  isUploadUserId?: boolean;
}

/**
 * 数数事件上报
 * @param {TaEventParams} params
 */
const taTrack = (params: TaEventParams) => {
  const { event, value = {}, isUploadUserId = false } = params
  const accountId = thinkingdata.persistence.getAccountId()
  const sendParams = { ...value } as any
  // 上传用户信息
  if (isUploadUserId && accountId) {
    sendParams.customer_id = accountId
  }
  thinkingdata.track(
    // 追踪事件的名称
    event,
    // 需要上传的事件属性
    sendParams
  )
}

// pageDuration.js

function usePageDuration (fn: (num: number) => void) {
  const startTime = ref<Date>(new Date())
  const endTime = ref<Date>(new Date())
  const duration = ref<number>(0)
  onMounted(() => {
    startTime.value = new Date() // 记录页面进入时间
  })

  onBeforeUnmount(() => {
    endTime.value = new Date() // 记录页面离开时间
    duration.value = +endTime.value - (+startTime.value) // 计算停留时长（以毫秒为单位）
    console.log(`页面停留时长：${duration.value}毫秒`)
    fn && fn(duration.value)
  })

  return {
    startTime,
    endTime,
    duration
  }
}

export { initThinkingData, thinkingdata, taTrack, TaEvent, usePageDuration }
